export const styles = () => ({
  container: {
    borderBottom: '1px solid #3A3F62',
    textAlign: 'center',
    fontSize: 14,
    margin: '16px 0',
  },
})
